import { PurchaseImportResponse } from '@/core/domain/purchase/purchaseImport/PurchaseImport.types';
import React, {
  createContext,
  useContext,
  useState,
  PropsWithChildren,
} from 'react';

type Props = PropsWithChildren<unknown>;

interface PurchaseImportContextParams {
  purchaseImportData?: PurchaseImportResponse;
  setPurchaseImportData: (
    purchaseImportFileData: PurchaseImportResponse,
  ) => void;
  xml?: File;
  setXml: (file: File) => void;
  setCompanyIdSelected: React.Dispatch<
    React.SetStateAction<number | undefined>
  >;
  companyIdSelected?: number;
}

export const PurchaseImportContext = createContext(
  {} as PurchaseImportContextParams,
);

export const usePurchaseImportFileContext = () =>
  useContext(PurchaseImportContext);

const PurchaseImportFileProvider: React.FC<Props> = ({ children }) => {
  const [purchaseImportData, setPurchaseImportData] =
    useState<PurchaseImportResponse>();

  const [companyIdSelected, setCompanyIdSelected] = useState<number>();

  const [xml, setXml] = useState<File>();

  return (
    <PurchaseImportContext.Provider
      value={{
        purchaseImportData,
        setPurchaseImportData,
        setXml,
        xml,
        companyIdSelected,
        setCompanyIdSelected,
      }}
    >
      {children}
    </PurchaseImportContext.Provider>
  );
};

export default PurchaseImportFileProvider;
